"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serialization_error_1 = require("../errors/serialization_error");
class PrimitiveSerializer {
    constructor(propertyName, options) {
        this.propertyName = propertyName;
        this.options = options;
    }
    down(value) {
        if (!this.options.optional && value === undefined) {
            throw new serialization_error_1.default(`Unable to serialize undefined property: "${this.propertyName}". Hint: make it optional`);
        }
        if (!this.options.nullable && value === null) {
            throw new serialization_error_1.default(`Unable to serialize null property: "${this.propertyName}". Hint: make it nullable`);
        }
        return this.expectPrimitiveOrNil(value);
    }
    up(value) {
        if (!this.options.optional && value === undefined) {
            throw new serialization_error_1.default(`Unable to deserialize undefined property: "${this.propertyName}". Hint: make it optional`);
        }
        if (!this.options.nullable && value === null) {
            throw new serialization_error_1.default(`Unable to deserialize null property: "${this.propertyName}". Hint: make it nullable`);
        }
        return this.expectPrimitiveOrNil(value);
    }
}
exports.default = PrimitiveSerializer;
//# sourceMappingURL=primitive_serializer.js.map